export function getMaxLengthChars(text, maxLength) {
  return text.length > maxLength ? text.slice(0, maxLength) : text;
}

export function formatDateStringFromTimestamp(timestamp) {
  const dt = new Date(timestamp);
  let mm = dt.getMonth() + 1; // Months start at 0
  let dd = dt.getDate();
  return `${mm}/${dd}`;
}

export function trimText(text, maxLength) {
  let sliced = text.slice(0, maxLength);
  if (sliced.length < text.length) {
    return (sliced += '...');
  } else {
    return text;
  }
}

// SECURITY: Safe text sanitization to prevent XSS attacks
export function sanitizeText(text) {
  if (!text) return '';
  
  // Convert to string first
  let cleanText = String(text);
  
  // FIXED: Strip common formatting tags that should not be visible
  cleanText = cleanText
    .replace(/<\/?p[^>]*>/gi, '') // Remove <p> and </p> tags
    .replace(/<\/?div[^>]*>/gi, '') // Remove <div> and </div> tags
    .replace(/<\/?span[^>]*>/gi, '') // Remove <span> and </span> tags
    .replace(/<br\s*\/?>/gi, '\n') // Convert <br> tags to newlines temporarily
    .replace(/<\/?[^>]+(>|$)/g, ''); // Remove any remaining HTML tags
  
  // Escape remaining HTML entities for safety
  cleanText = cleanText
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#x27;')
    .replace(/\//g, '&#x2F;');
  
  // Convert newlines to <br> tags for safe HTML display
  return cleanText.replace(/\n/g, '<br>');
}

// SECURITY: Safe HTML rendering with link detection
export function sanitizeTextWithLinks(text) {
  if (!text) return '';
  
  // For rich text content, use the more permissive sanitization
  const sanitized = sanitizeRichText(text);
  
  // Then apply safe link wrapping on the sanitized text
  return wrapLinksInText(sanitized);
}

// SECURITY: Sanitize rich text while preserving formatting tags
export function sanitizeRichText(text) {
  if (!text) return '';
  
  // Convert to string first
  let cleanText = String(text);
  
  // Define allowed HTML tags for rich text formatting
  const allowedTags = [
    'p', 'br', 'strong', 'b', 'em', 'i', 'u', 'ul', 'ol', 'li', 
    'blockquote', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'a'
  ];
  
  // Create regex to match allowed tags
  const allowedTagsRegex = new RegExp(`<\\/?(?:${allowedTags.join('|')})(?:\\s[^>]*)?>`, 'gi');
  
  // First extract all allowed tags
  const allowedTagMatches = cleanText.match(allowedTagsRegex) || [];
  
  // Create placeholders for allowed tags
  const tagPlaceholders = {};
  allowedTagMatches.forEach((tag, index) => {
    const placeholder = `__ALLOWED_TAG_${index}__`;
    tagPlaceholders[placeholder] = tag;
    cleanText = cleanText.replace(tag, placeholder);
  });
  
  // Remove all remaining HTML tags (potentially dangerous ones)
  cleanText = cleanText.replace(/<\/?[^>]+(>|$)/g, '');
  
  // Escape any remaining HTML entities for safety
  cleanText = cleanText
    .replace(/&(?!amp;|lt;|gt;|quot;|#x27;|#x2F;)/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;');
  
  // Restore allowed tags
  Object.keys(tagPlaceholders).forEach(placeholder => {
    cleanText = cleanText.replace(placeholder, tagPlaceholders[placeholder]);
  });
  
  return cleanText;
}

export function wrapLinksInText(text) {
  if (!text) return text;

  const urlRegex = /(?<!href\s*=\s*["']?)(?<!src\s*=\s*["']?)(https?:\/\/[^\s<]+)/gi;

  return text.replace(urlRegex, url => {
    return `<a href="${url}" target="_blank" rel="noopener noreferrer">${url}</a>`;
  });
}

export function containsForbiddenUsername(username) {
  if (!username) return false;
  return username.toLowerCase().includes('sezus');
}
